import { t } from 'i18next';
import { ResourcesCard, type ResourcesCardItem } from '../../../components/resources-card';
import { useSite } from '../../../context/page-context';
import { showIntercom } from '../../../lib/intercom';
import { getOnboardingMeetingLink } from '../lib/onboarding';

function getHelpItems(onboardingLink: string): ReadonlyArray<ResourcesCardItem> {
  return [
    {
      icon: 'document',
      title: t('features:home.components.additional_help_card.book_onboarding.title'),
      subtitle: t('features:home.components.additional_help_card.book_onboarding.subtitle'),
      onClick: () => window.open(onboardingLink, '_blank'),
    },
    {
      icon: 'infoCircle',
      title: t('features:home.components.additional_help_card.help_center.title'),
      subtitle: t('features:home.components.additional_help_card.help_center.subtitle'),
      onClick: () => window.open('https://docs.sparklayer.io', '_blank'),
    },
    {
      icon: 'chat',
      title: t('features:home.components.additional_help_card.chat.title'),
      subtitle: t('features:home.components.additional_help_card.chat.subtitle'),
      onClick: () => showIntercom(),
    },
  ];
}

export function AdditionalHelpCard() {
  const { userEmail } = useSite();
  const items = getHelpItems(getOnboardingMeetingLink(userEmail));

  return (
    <ResourcesCard
      title={t('features:home.components.additional_help_card.header')}
      items={items}
    />
  );
}
